import React from 'react';
import i18n from '../i18n';

const t = (key, fallback) => i18n.t(key, fallback);
const STARTUP_ERROR_KEY = 'tanzeen-startup-error';
const APP_CACHE_PREFIXES = ['tanzeen-web-', 'lea-quran-'];

export class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[RootErrorBoundary] Uncaught render error:', error, info);
    try {
      sessionStorage.setItem(STARTUP_ERROR_KEY, JSON.stringify({
        message: error?.message || String(error),
        stack: error?.stack?.slice(0, 2000) || null,
        componentStack: info?.componentStack?.slice(0, 2000) || null,
        timestamp: new Date().toISOString(),
      }));
    } catch (_) {}
  }

  handleReset = async () => {
    try {
      localStorage.removeItem('noor-settings');
      sessionStorage.removeItem(STARTUP_ERROR_KEY);

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }

      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames
            .filter((cacheName) => APP_CACHE_PREFIXES.some((prefix) => cacheName.startsWith(prefix)))
            .map((cacheName) => caches.delete(cacheName))
        );
      }
    } catch (_) {}
    window.location.replace('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: '16px',
          background: '#0f172a', color: '#f8fafc', padding: '24px', textAlign: 'center',
          fontFamily: 'system-ui, sans-serif',
        }} data-testid="root-error-boundary">
          <h1 style={{ fontSize: '1.4rem', fontWeight: 700 }}>{t('errors.somethingWentWrong', "Something went wrong")}</h1>
          <p style={{ fontSize: '0.95rem', color: '#cbd5e1', maxWidth: '320px' }}>
            The app hit an unexpected error. Tap below to reset and reload.
          </p>
          <button
            onClick={this.handleReset}
            data-testid="error-boundary-reset-btn"
            style={{
              padding: '12px 28px', borderRadius: '9999px', border: 'none',
              background: '#d97706', color: '#fff', fontWeight: 600, fontSize: '1rem',
            }}
          >
            Reset &amp; Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RootErrorBoundary;
